module.exports = __webpack_public_path__ + "img/less.58d121e9.png";